module.exports = __webpack_public_path__ + "static/media/3.3a4da964.jpg";